
import type { Router } from "vue-router"
export const navigateTo = (router: Router, routeLink: string): void => {
    router.push(routeLink)
}